import { Dispatch, SetStateAction, useEffect } from "react";
import Device from "../models/Device";
import { channelTypeInfo } from "../models/ChannelType";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { showToast } from "../components/Toasts";
import { useRedraw } from "../models/useRerender";
import { itx } from "../translationItx/itx";

export default function FullPhysicalAddressView(props: { device: Device; styleText?: any; styleOutline?: any }) {
  const { device, styleText, styleOutline } = props;

  const areaAddress = device.areaAddress;
  const lineAddress = device.lineAddress;
  const physicalAddress = device.physicalAddress;
  //const [currentFocused, setCurrentFocused] = useState(-1);

  useOnChangeWatcher(device);
  const redraw = useRedraw();

  useEffect(() => {
    const x = device.fullPhysicalAddress; // only needed if device has been created
    getFullAddressPartsFromTemplate(); // removed 7.11.2025 MWE
  }, []);

  function getFullAddressPartsFromTemplate() {
    if (device.physicalAddress == "") {
      if (device.template) {
        let mediumType = device.template.knxProductData.productInfo.MediumType || "";
        if (mediumType.includes(",")) {
          // Case of Coupler with different area and line mediums:
          // physical Address is always zero as per rules in Knx Software
          const mediumTypes = mediumType.split(",");
          device.lineAddress = device.mediumTypeAddress(mediumTypes[0]);
          device.areaAddress = device.mediumTypeAddress(mediumTypes[1]);
        } else {
          device.areaAddress = device.mediumTypeAddress(mediumType);
        }
      }

      device.findFreePhysicalAddress();

      redraw();
    }
  }

  const editableStyle = {
    fontSize: "0.75rem",
    padding: "0px",
    marginLeft: "0px",
    marginRight: "0px",
    textAlign: "left",
    minWidth: "1px",
    paddingBottom: "1px",
    with: "max-content",
    borderColor: "transparent",
    ...styleText,
  };
  // <div style={{ fontSize: "0.75rem" }}>{button.fullPhysicalAddress}</div>
  if (channelTypeInfo(device.channelType).isSupply || state.settings.customerView) {
    return <div></div>;
  }
  function focusElem(nextId: string, newNumb?: number, setFunct?: Dispatch<SetStateAction<string>>) {
    const nextElem = document.getElementById(nextId);
    if (nextElem) {
      if (setFunct) {
        setFunct(String(newNumb));
      }
      setTimeout(() => {
        nextElem.focus();
      }, 500);
    }
  }
  function updateChildCollection(oldAreaString?: string, oldLineString?: string) {
    const area = state.topologies.findFirst((area) => String(area.areaNumber) == device.areaAddress);
    const line = area?.lines.findFirst((line) => String(line.lineNumber) == device.lineAddress);
    area?.raiseOnChange("childCollection");
    line?.raiseOnChange("childCollection");
    state.topologies.raiseOnChange("childCollection");
    const oldArea = state.topologies.findFirst((area) => String(area.areaNumber) == oldAreaString);
    const oldLine = oldArea?.lines.findFirst((line) => String(line.lineNumber) == oldLineString);
    oldArea?.raiseOnChange("childCollection");
    oldLine?.raiseOnChange("childCollection");
  }

  return (
    <div
      key={`fullphysicaladdress_${device.fullPhysicalAddress}`}
      style={{ fontSize: styleText?.fontSize || "0.75rem", display: "flex", flexDirection: "row", ...styleOutline }} // no itx
      id="fullphysicalAddress"
    >
      <input
        className="groupAddress withoutArrow"
        id="areaAddress"
        type={"number"} // no itx
        defaultValue={areaAddress}
        key={`area-${areaAddress}`}
        style={{ ...editableStyle, width: "40px" }}
        onBlur={(ev) => {
          const maxValue = 15;
          let oldAreaString: string | undefined = device.areaAddress;
          let oldLineString: string | undefined = device.lineAddress;
          let oldPhysicalString: string | undefined = device.physicalAddress;
          if (parseInt(ev.target.value) >= 0 && parseInt(ev.target.value) <= maxValue) {
            device.areaAddress = String(parseInt(ev.target.value));
            device.setPhysicalAddressWithAutoRenumbering(device.physicalAddress);
            device.raiseOnChange("areaAddress");
            updateChildCollection(oldAreaString, oldLineString);
          }
          if (ev.target.value != device.areaAddress) {
            showToast({
              text: state.translate("adjustValue", "Der Wert wurde durch Estada angepasst.", {
                T1: ev.target.value,
                T2: device.areaAddress,
              }),
            });
          } else if (oldPhysicalString != device.physicalAddress) {
            showToast({
              text: itx(
                "FullPhysicalAddressView.adjustValuePhysicalAddress",
                "Der Wert der physikalischen Adresse wurde durch Estada angepasst. T1-> T2",
                {
                  T1: oldPhysicalString,
                  T2: device.physicalAddress,
                },
              ),
            });
          }

          ev.target.value = device.areaAddress;
          // get area to set onchange
        }}
        onKeyDown={(ev) => {
          if (ev.key == "ArrowRight" || ev.key == "Enter") {
            focusElem("lineAddress"); // no itx
          }
        }}
      />
      .
      <input
        className="groupAddress withoutArrow"
        id="lineAddress"
        type="number" // no itx
        key={`line-${lineAddress}`}
        defaultValue={lineAddress}
        style={{ ...editableStyle, width: "40px" }}
        onBlur={(ev) => {
          const maxValue = 63;
          let oldAreaString: string | undefined = device.areaAddress;
          let oldLineString: string | undefined = device.lineAddress;
          let oldPhysicalString: string | undefined = device.physicalAddress;
          if (parseInt(ev.target.value) >= 0 && parseInt(ev.target.value) <= maxValue) {
            device.lineAddress = String(parseInt(ev.target.value));
            device.setPhysicalAddressWithAutoRenumbering(device.physicalAddress);
            device.raiseOnChange("lineAddress");

            updateChildCollection(oldAreaString, oldLineString);
          }
          if (ev.target.value != device.lineAddress) {
            showToast({
              text: state.translate("adjustValue", "Der Wert wurde durch Estada angepasst.", {
                T1: ev.target.value,
                T2: device.lineAddress,
              }),
            });
          } else if (oldPhysicalString != device.physicalAddress) {
            showToast({
              text: itx(
                "FullPhysicalAddressView.adjustValuePhysicalAddress",
                "Der Wert der physikalischen Adresse wurde durch Estada angepasst. T1-> T2",
                {
                  T1: oldPhysicalString,
                  T2: device.physicalAddress,
                },
              ),
            });
          }

          ev.target.value = device.lineAddress;
        }}
        onKeyDown={(ev) => {
          if (ev.key == "ArrowRight" || ev.key == "Enter") {
            focusElem("physicalAddress"); // no itx
          } else if (ev.key == "ArrowLeft") {
            focusElem("areaAddress"); // no itx
          }
        }}
      />
      .
      <input
        className="groupAddress withoutArrow"
        id="physicalAddress"
        style={{ ...editableStyle, width: "60px" }}
        key={`physical-${physicalAddress}`}
        defaultValue={physicalAddress}
        onBlur={(ev) => {
          const maxValue = 255;
          if (parseInt(ev.target.value) >= 0 && parseInt(ev.target.value) <= maxValue) {
            device.setPhysicalAddressWithAutoRenumbering(String(parseInt(ev.target.value)));
            device.raiseOnChange("physicalAddress");
            updateChildCollection();
          }

          if (ev.target.value != device.physicalAddress) {
            showToast({
              text: state.translate("adjustValue", "Der Wert wurde durch Estada angepasst.", {
                T1: ev.target.value,
                T2: device.physicalAddress,
              }),
            });
          }

          ev.target.value = device.physicalAddress;
        }}
        onKeyDown={(ev) => {
          if (ev.key == "ArrowLeft") {
            focusElem("lineAddress"); // no itx
          }
          if (ev.key == "Enter") {
            (ev.target as HTMLInputElement).blur();
          }
        }}
      />
    </div>
  );
}
